import { AnimationKey } from '../../../lib/types'
import { withPublicAssetUrl } from '../../../lib/utils/cdn'

const animationKeyToSourceFile: { [key in AnimationKey]: string } = {
  [AnimationKey.LlamaShowcase]: 'animations/llama.json',
  [AnimationKey.ProfessionalOutcomes]: 'animations/professional_outcomes.json',
  [AnimationKey.CheckTypes]: 'animations/check_types.json',
  [AnimationKey.StudentLP]: 'animations/student_lp.json',
  [AnimationKey.AbstractCommunicate]: 'animations/abstract_communicate.json',
  [AnimationKey.AbstractWaves]: 'animations/abstract_waves.json',
  [AnimationKey.Fluency]: 'animations/fluency.json',
  [AnimationKey.OffensiveContentReporting]: 'animations/offensive_content_reporting.json',
  [AnimationKey.Director]: 'animations/director.json',
}

export const getAnimationDataSourceUrl = (animationKey: AnimationKey): string => {
  return withPublicAssetUrl(animationKeyToSourceFile[animationKey])
}
